









































































































import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const dateFormat = require('bmh/date-format');
const API = {
  get_list: `${FCAPI}/shang/ruan/community`,
  edit: `${FCAPI}/shang/ruan/community/`,
};
const STATUS = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '上架中',
  },
  {
    value: 2,
    label: '已下架',
  },
];
function initCommunityData(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
function initForm() {
  return {
    name: '',
    city: '',
    status: 0,
  };
}
@Component
export default class CommunityList extends Vue {
  active_index: number = -1;
  community_data: any = initCommunityData();
  form: any = initForm();
  is_loading: boolean = false;
  old_value: string = '';
  get status() {
    return STATUS;
  }

  // 跳转到新增小区页面
  addCommunity(record?: any) {
    const url = record.id ? `/operation/add-community?id=${record.id}` : `/operation/add-community`;
    this.$router.push(url);
  }

  paginationOption(data: any) {
    return {
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 0,
      total: data.total || 0,
      current: data.current || 0,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  // 关闭修改排序输入框
  closeInput(record: any) {
    this.active_index = -1;
    record.sort = this.old_value;
    this.old_value = '';
  }

  // 清空搜索框
  clearForm() {
    this.form = initForm();
  }

  // 展示修改排序输入框
  showInput(index: number, record: any) {
    this.active_index = index;
    this.old_value = record.sort;
  }

  // 更改排序值
  @changeLoading(['is_loading'])
  async changeSort(record: any) {
    const res = await this.$axios.put(`${API.edit}${record.id}`, {
      sort: record.sort,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.active_index = -1;
    await this.getCommunityList();
  }

  // 切换状态
  @changeLoading(['is_loading'])
  async changeStatus(record: any) {
    const res = await this.$axios.put(`${API.edit}${record.id}`, {
      is_show: record.is_show === 1 ? 2 : 1,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    await this.getCommunityList();
  }

  // 切换分页
  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    await this.getCommunityList({
      current: data.current,
      name: this.form.name,
      city: this.form.city,
      is_show: this.form.status,
    });
  }

  // 点击搜索按钮
  @changeLoading(['is_loading'])
  async clickSearchBtn() {
    await this.getCommunityList({
      name: this.form.name,
      city: this.form.city,
      is_show: this.form.status,
    });
  }

  // 获取小区列表
  @changeLoading(['is_loading'])
  async getCommunityList(query_params: any = {}) {
    const url = getUrl(API.get_list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.community_data = initCommunityData(res.data.data);
  }

  @changeLoading(['is_loading'])
  async created() {
    await this.getCommunityList();
  }
}
